/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-console */
import { Dispatch, PayloadAction, Store } from '@reduxjs/toolkit';
import moment from 'moment';
import {
    Cancel,
    Info,
    Invitation,
    Inviter,
    InviterOptions,
    Notification,
    Registerer,
    RegistererState,
    Session,
    SessionState,
    URI,
    UserAgent,
    UserAgentOptions,
    Web
} from 'sip.js';
import { z } from 'zod';
import { SessionDescriptionHandler } from 'sip.js/lib/platform/web';
import { IncomingRequestMessage, OutgoingInviteRequestDelegate } from 'sip.js/lib/core';
import { Body } from 'sip.js/lib/core/messages/body';
import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';
import { AppDispatch, EVENT_SOCKET_STATUS, RootState } from '../store';
import { SocketBackoff } from '../SocketBackoff';
import {
    addOneToast,
    appSlice,
    callsSlice,
    getGlobalSettings,
    handleNewVoicemail,
    selectConfiguredCrmIntegrations,
    selectDnd,
    selectHasDevices,
    selectSmartDiallerSelected,
    userSlice
} from '../slices';
import { AssertedIdentity, CRMPop, ICall, ICRMIntegration, IPhoneSettings } from '../../types';
import { isCallSwitch, isPreview, isTesting, isYay, playCallWaiting, playRingtone, stopRingtone } from '../../helpers';
import { api } from '../../api';
import { sipApi } from '../services/sipApi';
import { SocketStatus } from '../services';
import { SocketAuthStatus } from '../web-socket/webSocket';

export interface SIPLogin {
    username: string;
    password: string;
    isAus: boolean;
}

interface ISIPPayload {
    callId: string;
    callee?: string;
    isMuted?: string;
    onHold?: string;
    displayName?: string;
}

let userAgentString: string;

switch (true) {
    case isYay:
        userAgentString = 'Yay.com 5.0';
        break;

    case isCallSwitch:
        userAgentString = 'CallSwitch One 5.0';
        break;

    default:
        userAgentString = 'PulseHd 5.0';
}

export interface SipServer {
    server: string,
    uri: string,
}

export const SIP_YAY: SipServer = { server: 'wss://talk.yay.com/', uri: 'talk.yay.com' };
export const SIP_YAY_AU: SipServer = { server: 'wss://au.talk.yay.com/', uri: 'au.talk.yay.com' };
export const SIP_WL: SipServer = { server: 'wss://talk.voipcp.com/', uri: 'talk.voipcp.com' };

export const SIP_PREVIEW: SipServer = { server: 'wss://talk-preview.yay.com/', uri: 'talk-preview.yay.com' };
export const SIP_TESTING: SipServer = { server: 'wss://talk-testing.yay.com/', uri: 'talk-testing.yay.com' };

export function getDefaultSipServer() {
    if (isTesting) {
        return SIP_TESTING;
    }
    if (isPreview) {
        return SIP_PREVIEW;
    }
    if (isYay) {
        return SIP_YAY;
    }

    return SIP_WL;
}

let sipServer = getDefaultSipServer();

export function getCurrentSipServer(): SipServer {
    return { ...sipServer }
};

let userAgent: UserAgent | undefined;
let registerer: Registerer | undefined;
let calls: (Inviter | Invitation)[] = [];
// TODO: Clean up bodyDictionary/callStatusDictionary on call terminated
const bodyDictionary: { [key: string]: Body } = {};
const callsOnHold = {};
let callStatusDictionary: Record<string, { last_code: number; did_ring: boolean }> = {};

let dnd = false;
let callWaitingBeepOff = false;
let allowInternalCalls = false;
let bringAppToFrontOff = false;
let collectCallFeedback = false;
let popCrm: CRMPop = 'never';
let popWhenAnswered = false;
let ringtoneVolumeValue = 100;

// Status Params
let connectionStatus: SocketAuthStatus = 0;
export const checkSipSocket = (): SocketStatus => {
    if (!userAgent) return 'closed';

    if (!userAgent.isConnected()) return 'no_connection';

    if (connectionStatus !== 1) return "no_auth";

    return 'ok';
}

// Used to guard against overlapping reconnection attempts
let attemptingReconnection = false;
let registering = false;
const reconnectBackoff = new SocketBackoff();

const MIN_REGISTER_INTERVAL_MS = 10_000;
let lastRegisterAt = 0;
let registerRetryTimer: ReturnType<typeof setTimeout> | null = null;

/**
 * Handle deregister of SIP socket when page destructs.
 *
 * Handles:
 *  - Refresh
 *  - Navigate away
 *  - Tab / Window Close
 *
 * bfcache, I'm trying to test this one a bit more, the heap snapshot can keep
 * the registration.
 *
 * No Fire on:
 *  - Tab Switch
 *  - Os Sleep
 *  - Network DC ~ Needs to be handled on nebula
 */
function deregisterOnUnload(event: PageTransitionEvent): void {
    if (event.persisted || !registerer) return;
    try {
        registerer.unregister().catch(() => { /* Can't have async retry here */ });
    } catch {
        /* Nebula will have to clean up at this point */
    }
}
window.addEventListener('pagehide', deregisterOnUnload);

async function registerUserAgent(ua: UserAgent): Promise<void> {
    if (registering) return;

    const now = Date.now();
    const since = now - lastRegisterAt;
    if (since < MIN_REGISTER_INTERVAL_MS) {
        if (!registerRetryTimer) {
            registerRetryTimer = setTimeout(() => {
                registerRetryTimer = null;
                if (userAgent) {
                    registerUserAgent(userAgent).catch(e => console.error("Failed Register", e));
                }
            }, MIN_REGISTER_INTERVAL_MS - since);
        }
        return;
    }

    registering = true;
    lastRegisterAt = now;

    try {
        if (registerer) {
            const stale = registerer;
            registerer = undefined;
            try {
                await stale.dispose();
            } catch (e) {
                console.warn("Failed to dispose previous registerer", e);
            }
        }

        const reg = new Registerer(ua as UserAgent, {
            expires: 3_600,
            // 98% of 3600s -> 3528s
            refreshFrequency: 98
        });
        registerer = reg;

        reg.stateChange.addListener(newState => {
            if (reg !== registerer) return;
            switch (newState) {
                case RegistererState.Registered:
                    connectionStatus = 1;
                    break;
                case RegistererState.Unregistered:
                case RegistererState.Terminated:
                    connectionStatus = 2;
                    break;
                default:
                    return;
            }
            window.dispatchEvent(new Event(EVENT_SOCKET_STATUS));
        });

        reg.register({
            requestDelegate: {
                onAccept: () => {
                    if (reg !== registerer) return;
                    connectionStatus = 1;
                    window.dispatchEvent(new Event(EVENT_SOCKET_STATUS));
                },
                onReject: () => {
                    if (reg !== registerer) return;
                    connectionStatus = 2;
                    window.dispatchEvent(new Event(EVENT_SOCKET_STATUS));
                },
            }
        });
    } finally {
        registering = false;
    }
}

const attemptReconnection = (): void => {
    // Reconnection attempt already in progress
    if (attemptingReconnection) {
        return;
    }

    // We're attempting a reconnection
    attemptingReconnection = true;

    const delay = Math.max(10_000, reconnectBackoff.getNextBackoff());

    setTimeout(() => {
        // No UserAgent to reconnect — creation is owned by connectSip (login), not
        // the reconnect loop. Abort rather than spin a futile timer forever.
        if (!userAgent) {
            attemptingReconnection = false;
            reconnectBackoff.reset();
            return;
        }

        // Transport is healthy and only the registration lapsed — re-register
        // rather than tearing down a working connection.
        if (userAgent.isConnected()) {
            attemptingReconnection = false;
            reconnectBackoff.reset();
            registerUserAgent(userAgent)
                .catch(e => console.error("Failed Register", e));
            return;
        }

        // Attempt reconnect
        userAgent
            .reconnect()
            .then(() => {
                // Reconnect attempt succeeded
                attemptingReconnection = false;
                reconnectBackoff.reset();
                registerUserAgent(userAgent as UserAgent)
                    .catch(e => {
                        console.error("Failed Register", e);
                    });
            })
            .catch(() => {
                // Reconnect attempt failed
                attemptingReconnection = false;
                attemptReconnection();
            });
    }, delay);
};

export const recoverSipSocket = () => attemptReconnection();

export interface EmisCallInfo {
    callState: 'ringing' | 'answered' | 'ended';
    callType: 'inbound' | 'outbound';
    callingNumber: string | undefined;
    calledNumber: string | undefined;
}

const partyNumber = (
    uriUser: string | undefined,
    sipName: string,
    extension: number
): string | undefined =>
    uriUser && uriUser.toLowerCase() === sipName?.toLowerCase() ? String(extension) : uriUser;

export const integrationChecker = (
    integration: ICRMIntegration,
    userUri: string | undefined,
    crmDir: typeof popCrm,
    countryCode: CountryCode,
    inboundCdrUuid: string | undefined,
    userUuid: string,
    dispatch: AppDispatch,
    emis?: EmisCallInfo
) => {
    if (!userUri) return;

    const toNumber = parsePhoneNumberFromString(userUri, countryCode);

    if (!toNumber || !toNumber.nationalNumber) return;

    api.matchIntegrationNumber({
        uriUser: `0${toNumber?.nationalNumber}`,
        integrationUuid: integration.uuid,
        inboundCdrUuid,
        userUuid
    })
        .then(response => {
            if (response.status === 204) return;

            const parsed = z.array(z.string()).safeParse(response.data?.result);

            if (parsed.error || parsed.data.length < 1) {
                return;
            }

            if (integration.name === 'EMIS') {
                if (!emis) {
                    return;
                }

                const content = `Session token : ${parsed.data[0]}\nCall Type : ${emis.callType}\nCall State : ${emis.callState}\n${JSON.stringify(
                    {
                        from: emis.callingNumber,
                        to: emis.calledNumber,
                    }
                )}`;

                dispatch(addOneToast({
                    type: 'info',
                    title: 'EMIS call',
                    content,
                }));

                const notifyEmis = emis.callState === 'ended'
                    ? api.emisCallEnded
                    : api.emisCallAnswered;

                notifyEmis({
                    sessionToken: parsed.data[0],
                    uuid: parsed.data[0],
                    callType: emis.callType,
                    from: emis.callingNumber,
                    to: emis.calledNumber,
                }).catch(() => { /* ignoring the response for now */ });
                return;
            }

            if (response.data.result.length > 0) {
                if (crmDir === 'new') {
                    window.open(response.data.result[0]);
                } else {
                    window.open(response.data.result[0], 'crm_pop');
                }
                // TODO - We should save this window and re-use it if possible
            }
        })
        .catch(() => {
            // We can ignore these for now
        });
};

function checkDTMFPass(eventStr: string) {
    const { electron } = (window as any);

    if (!electron || !electron.send) {
        return;
    }

    electron.send('simulate-keyboard-input', eventStr);
}

const SipHeader = {
    InternalCall: 'X-Internal-Call',
    RoomId: 'X-Room-Id',
    RoomAuthToken: 'X-Room-Auth-Token',
    CdrUuid: 'X-Cdr-Uuid',
    Ctd: 'X-Click-To-Dial',
    AssertedIdentity: 'P-Asserted-Identity'
};

let lock = false;

const connectSip = async ({ username, password, isAus }: SIPLogin, store: Store) => {
    if (lock) {
        return;
    }
    lock = true;

    if (isYay && isAus) {
        sipServer = SIP_YAY_AU;
    }

    if (isPreview) {
        const localServeStr: string | null = localStorage.getItem('local_serve');
        let localServe: { server: string; uri: string; count: number; date: number } | undefined;

        if (localServeStr) {
            try {
                localServe = JSON.parse(localServeStr);

                if (localServe?.server && localServe?.uri) {
                    sipServer = localServe;
                }
            } catch {
                console.error('Failed to parse sip proxy server');
            }
        }
    }

    const userAgentOptions: UserAgentOptions = {
        authorizationUsername: username,
        authorizationPassword: password,
        transportOptions: { server: sipServer.server },
        userAgentString,
        uri: UserAgent.makeURI(`sip:${username}@${sipServer.uri}`),
        sessionDescriptionHandlerFactoryOptions: {
            peerConnectionConfiguration: {
                bundlePolicy: 'max-compat',
                iceServers: []
            }
        },
        allowLegacyNotifications: true,
        noAnswerTimeout: 9999,
        logLevel: 'warn',
        delegate: {
            onInvite: invitation => {
                const settings: IPhoneSettings = (store.getState() as RootState).user.settings
                    ?.phone.settings;
                const callsRedux: ICall[] = (store.getState() as RootState).sip.calls;
                const sipRedux = (store.getState() as RootState).sip;
                const { extension, country_code, uuid: userUuid, name: sipName } = (store.getState() as RootState).user;
                dnd = selectDnd(store.getState()).dnd;

                if (settings?.popCrm) {
                    popCrm = settings.popCrm;
                }

                if (settings?.popWhenAnswered) {
                    popWhenAnswered = settings.popWhenAnswered;
                }

                if (sipRedux.callFeedback.enabled) {
                    collectCallFeedback = sipRedux.callFeedback.enabled;
                }

                if (settings?.allowInternalCalls) {
                    allowInternalCalls = settings.allowInternalCalls;
                }

                if (settings?.callWaitingBeepOff) {
                    callWaitingBeepOff = settings.callWaitingBeepOff;
                }

                if (settings?.ringtoneVolumeValue) {
                    ringtoneVolumeValue = settings.ringtoneVolumeValue;
                }

                bringAppToFrontOff = settings.bringAppToFrontOff || false;

                const crmIntegrations = selectConfiguredCrmIntegrations(store.getState() as RootState);

                if (
                    (dnd && !allowInternalCalls) ||
                    (dnd &&
                        allowInternalCalls &&
                        invitation.request.getHeader(SipHeader.InternalCall) !== 'true')
                ) {
                    invitation.reject({
                        statusCode: 480,
                        reasonPhrase: 'User On Do Not disturb'
                    });
                } else {
                    const roomId = invitation.request.getHeader(SipHeader.RoomId);
                    const auth_token = invitation.request.getHeader(SipHeader.RoomAuthToken);
                    const cdr = invitation.request.getHeader(SipHeader.CdrUuid);
                    const fromExtension = invitation.request.parseHeader('From').uri.raw.user;
                    const initGroup = callsRedux.find(
                        c => c.id === 'group_init' && c.roomId === roomId
                    );

                    if (roomId && fromExtension === String(extension) && !initGroup) {
                        invitation.reject();
                        return;
                    }

                    if (
                        calls.some(call =>
                            [
                                SessionState.Initial,
                                SessionState.Establishing,
                                SessionState.Established
                            ].includes(call.state)
                        ) ||
                        callsRedux.some(
                            call =>
                                call.state &&
                                [
                                    SessionState.Initial,
                                    SessionState.Establishing,
                                    SessionState.Established
                                ].includes(call.state)
                        )
                    ) {
                        if (!callWaitingBeepOff) playCallWaiting();
                    } else if (!initGroup)
                        playRingtone({ callId: invitation.id, volume: ringtoneVolumeValue });

                    if (crmIntegrations && popCrm !== 'never' && !popWhenAnswered) {
                        const emisInfo: EmisCallInfo = {
                            callState: 'ringing',
                            callType: 'inbound',
                            callingNumber: partyNumber(invitation.request.from.uri.user, sipName, extension),
                            calledNumber: partyNumber(invitation.request.to.uri.user, sipName, extension),
                        };
                        crmIntegrations.forEach(integration => {
                            integrationChecker(
                                integration,
                                invitation.request.from.uri.user,
                                popCrm,
                                country_code,
                                cdr,
                                userUuid,
                                store.dispatch,
                                integration.name === 'EMIS' ? emisInfo : undefined
                            );
                        });
                    }

                    if (!bringAppToFrontOff && (window as any).electron) {
                        (window as any).electron.send('bring-window-to-front');
                        window.focus();
                    }

                    if ((window as any).electron) {
                        if (invitation.state === SessionState.Initial) {
                            (window as any).electron.send('set-touch-bar', {
                                type: 'initial-call',
                                payload: {
                                    id: invitation.id,
                                    number: invitation.remoteIdentity?.uri?.user
                                }
                            });
                        } else {
                            (window as any).electron.send('set-touch-bar', { type: 'clear' });
                        }
                    }

                    calls = [...calls, invitation];

                    const newCallObj: ICall = {
                        id: invitation.id,
                        displayName: invitation.remoteIdentity?.displayName,
                        callee: invitation.remoteIdentity?.uri?.user,
                        state: invitation.state,
                        callSipId: invitation.request.callId,
                        roomId,
                        auth_token,
                        cdr
                    };

                    // if (replyStr) {
                    //     newCallObj.callSipId = replyStr;
                    // }

                    // if (roomId) {
                    //     newCallObj.roomId = roomId;
                    //     newCallObj.auth_token = auth_token;
                    //     newCallObj.state = SessionState.Initial;
                    //
                    //     store.dispatch(callsSlice.actions.newCall(newCallObj));
                    //     return;
                    // }

                    store.dispatch(callsSlice.actions.newCall(newCallObj));

                    if (
                        (store.getState() as RootState).user.settings.phone.settings
                            ?.autoAnswerClickToDial &&
                        invitation.request.getHeader(SipHeader.Ctd) === 'true' &&
                        calls.every(
                            call =>
                                ![SessionState.Establishing, SessionState.Established].includes(
                                    call.state
                                )
                        )
                    ) {
                        store.dispatch({
                            type: 'sip/answer',
                            payload: invitation.id
                        });
                    }

                    // Handler for when a received attended transfer is confirmed
                    handleCallDialog(invitation, store);

                    invitation.stateChange.addListener((state: SessionState) => {
                        switch (state) {
                            case SessionState.Established:
                                if (roomId) {
                                    break;
                                }
                                console.log(`sip/incoming-invitation state changed to ${state}`);
                                if (crmIntegrations && popCrm !== 'never' && popWhenAnswered) {
                                    const emisInfo: EmisCallInfo = {
                                        callState: 'answered',
                                        callType: 'inbound',
                                        callingNumber: partyNumber(invitation.request.from.uri.user, sipName, extension),
                                        calledNumber: partyNumber(invitation.request.to.uri.user, sipName, extension),
                                    };
                                    crmIntegrations.forEach(integration => {
                                        integrationChecker(
                                            integration,
                                            invitation.request.from.uri.user,
                                            popCrm,
                                            country_code,
                                            cdr,
                                            userUuid,
                                            store.dispatch,
                                            integration.name === 'EMIS' ? emisInfo : undefined
                                        );
                                    });
                                }

                                // this sets the active call id, so it can be reference when providing call feedback
                                if (collectCallFeedback && invitation.cdrUuid) {
                                    const cdrUuid = invitation.cdrUuid?.trim();

                                    const isInternal =
                                        invitation.remoteIdentity?.uri?.user &&
                                        invitation.remoteIdentity?.uri?.user.length <= 5;

                                    if (cdrUuid && !isInternal) {
                                        store.dispatch(
                                            callsSlice.actions.addSingleFeedbackForm({
                                                invite_uuid: invitation.id,
                                                call_uuid: cdrUuid,
                                                note: undefined,
                                                mood: undefined,
                                                active_tags: []
                                            })
                                        );
                                    }
                                }
                                break;

                            case SessionState.Terminating:
                            case SessionState.Terminated:
                                const inviteCall = (store.getState() as RootState).sip.calls.find(
                                    call => call.id === invitation.id
                                );

                                if (!inviteCall || !inviteCall?.answered) {
                                    console.log(
                                        `sip/incoming-invitation state changed to ${state}`
                                    );

                                    if (inviteCall.getCdr && inviteCall.cdr) {
                                        store.dispatch(sipApi.endpoints.getCallResolution.initiate({ call_uuid: inviteCall.cdr, callee: inviteCall.callee }) as any);
                                    }

                                    store.dispatch(
                                        callsSlice.actions.callTerminating({
                                            id: invitation.id
                                        })
                                    );

                                    setTimeout(() => {
                                        store.dispatch(
                                            callsSlice.actions.callTerminated({
                                                id: invitation.id
                                            })
                                        );
                                    }, 1500);
                                }

                                // Only ever one EMIS integration per account
                                const emisIntegration = crmIntegrations?.find(
                                    integration => integration.name === 'EMIS'
                                );

                                if (
                                    state === SessionState.Terminated &&
                                    emisIntegration &&
                                    popCrm !== 'never'
                                ) {
                                    const emisEnded: EmisCallInfo = {
                                        callState: 'ended',
                                        callType: 'inbound',
                                        callingNumber: partyNumber(invitation.request.from.uri.user, sipName, extension),
                                        calledNumber: partyNumber(invitation.request.to.uri.user, sipName, extension),
                                    };

                                    integrationChecker(
                                        emisIntegration,
                                        invitation.request.from.uri.user,
                                        popCrm,
                                        country_code,
                                        cdr,
                                        userUuid,
                                        store.dispatch,
                                        emisEnded
                                    );
                                }

                                (window as any).electron?.send('set-touch-bar', { type: 'clear' });
                                break;

                            default:
                                break;
                        }
                    });
                }
            },
            onDisconnect: (error?: Error) => {
                window.dispatchEvent(new Event(EVENT_SOCKET_STATUS));
                /* Todo: Maybe cancel calls when server disconnect
                console.error('SIP disconnected', error);

                const state = store.getState();
                const stateCalls = selectAllCalls(state);

                stateCalls.forEach(call => {
                    const {
                        name,
                    } = selectCallerDisplayNameGeneric(state, call.assertedIdentity?.number || call.callee);

                    store.dispatch({
                        type: 'sip/end-call',
                        payload: call.id
                    });

                    store.dispatch(addOneToast({
                        content: `Call with ${name || call.callee} dropped due to connection failure`,
                        title: "Call Failed",
                        type: "error"
                    }) as any);
                })
                */

                // Only attempt to reconnect if network/server dropped the connection (if there is an error)
                if (error) {
                    attemptReconnection();
                }
            },
            onNotify(notification: Notification) {
                const event = notification.request.getHeader('Event');
                const notificationBody = notification.request.body;

                if (!event) {
                    console.error("Notified with no event");
                    return;
                }

                if (event.startsWith('VOICEMAIL')) {
                    const [mailbox_uuid, voicemail] = notificationBody.split(':');

                    if (
                        !mailbox_uuid ||
                        !voicemail ||
                        mailbox_uuid.length !== 36 ||
                        voicemail.length !== 36
                    ) {
                        return;
                    }

                    switch (event) {
                        case 'VOICEMAIL-NEW':
                            store.dispatch(handleNewVoicemail(mailbox_uuid, voicemail) as any);
                            break;
                        case 'VOICEMAIL-SEEN':
                            store.dispatch(
                                callsSlice.actions.updateOneVoicemail({
                                    mailbox_uuid,
                                    id: voicemail,
                                    changes: {
                                        is_new: false
                                    }
                                })
                            )
                            store.dispatch(callsSlice.actions.mailboxMessageSeen({ mailbox_uuid }));
                            break;
                        case 'VOICEMAIL-REMOVE':
                            store.dispatch(callsSlice.actions.removeOneVoicemail({ mailbox_uuid, voicemail }));
                            break;
                        case 'VOICEMAIL-REMOVE-UNSEEN':
                            store.dispatch(callsSlice.actions.removeOneVoicemail({ mailbox_uuid, voicemail }));
                            store.dispatch(callsSlice.actions.mailboxMessageSeen({ mailbox_uuid }));
                            break;
                        default:
                            console.error("Invalid voicemail notify type", event);
                            return;
                    }
                }

                switch (event) {
                    case 'GLOBAL-SETTING':
                        if (notificationBody === 'UPDATED') {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            store.dispatch(getGlobalSettings(notificationBody));
                        }
                        break;
                    default:
                        break;
                }
            },
        }
    };

    userAgent = new UserAgent(userAgentOptions);
    try {
        await userAgent.start();
    } catch (error) {
        console.warn(error);
    }

    registerUserAgent(userAgent as UserAgent)
        .catch(e => {
            console.error("Failed Register", e);
        });
};

function handleCallDialog(initiator: Inviter | Invitation, store: Store) {
    initiator.delegate = {
        onInvite: (innerReq: IncomingRequestMessage) => {
            const assertionIdentity = innerReq.getHeader(SipHeader.AssertedIdentity);

            if (assertionIdentity) {
                const assertedIdentity = parseAssertedIdentity(assertionIdentity);

                store.dispatch(
                    callsSlice.actions.updateCall({
                        id: initiator.id,
                        assertedIdentity
                    })
                );
            }

            const assertionRoomID = innerReq.getHeader(SipHeader.RoomId);
            const assertionRoomAuth = innerReq.getHeader(SipHeader.RoomAuthToken);

            if (assertionRoomID && assertionRoomAuth) {
                store.dispatch(
                    callsSlice.actions.updateCall({
                        id: initiator.id,
                        roomId: assertionRoomID,
                        auth_token: assertionRoomAuth
                    })
                );
            }
        },
        onCancel: (cancel: Cancel) => {
            const cancel_request = cancel.request;

            const reason = cancel_request.getHeader('Reason');
            if (reason && reason === 'SIP;cause=200;text="Call completed elsewhere"') {
                store.dispatch(
                    callsSlice.actions.updateCall({
                        id: initiator.id,
                        getCdr: true
                    })
                );
            }
        },
        onInfo: (info: Info) => {
            const contentType = info.request.getHeader('Content-Type');
            const infoBody = info.request.body;

            switch (contentType) {
                case 'application/dtmf-pass-toggle':
                    store.dispatch(callsSlice.actions.updateCall({
                        id: initiator.id,
                        dtmfpass: infoBody === 'true',
                    }))
                    break;
                case 'application/dtmf-pass-key':
                    checkDTMFPass(infoBody);
                    break;
                default:
                    console.log('Unknown content type:', contentType);
            }
        }
    };
}

function toggleDTMFPass(initiator: Inviter | Invitation) {
    initiator.dialog?.info({
    }, {
        extraHeaders: [
            'Content-Type: application/dtmf-pass'
        ],
        body: {
            contentType: 'application/dtmf-pass',
            content: 'enable',
            contentDisposition: 'session',
        }
    });
}

// TODO - Check if this is even needed if using go aus check
// const testYaySipServers = async (username: string, password: string) => {
//     const localServeStr: string | null = localStorage.getItem('local_serve');
//     let localServe: { server: string; uri: string; count: number; date: number } | undefined;
//
//     if (localServeStr) {
//         try {
//             localServe = JSON.parse(localServeStr);
//         } catch {}
//     }
//
//     // Reset localServe if number of servers have changed or if last
//     // get was more than 12 hours ago
//     if (
//         localServe &&
//         localServe.count === serverArr.length &&
//         localServe.date > moment().subtract(12, 'hours').unix()
//     ) {
//         server = localServe.server;
//         alteredUri = localServe.uri;
//         return;
//     }
//
//     const promises = serverArr.map(item =>
//         testUserAgent(item.server, item.uri, username, password)
//     );
//
//     let cur: number | undefined;
//     let found: { server: string; uri: string } | undefined;
//
//     await Promise.allSettled(promises).then((r: any[]) => {
//         for (let i = 0; i < r.length; i += 1) {
//             if (r[i].value !== Infinity && (!cur || cur > r[i].value)) {
//                 cur = r[i].value;
//                 found = serverArr[i];
//             }
//         }
//     });
//
//     if (found) {
//         localStorage.setItem(
//             'local_serve',
//             JSON.stringify({
//                 ...found,
//                 count: serverArr.length,
//                 date: moment().unix()
//             })
//         );
//
//         server = found.server;
//         alteredUri = found.uri;
//     }
// };
//
// const testUserAgent = (
//     serverToCheck: string,
//     uriToCheck: string,
//     username: string,
//     password: string
// ) =>
//     new Promise<number>(resolve => {
//         const userAgentOptions: UserAgentOptions = {
//             authorizationUsername: username,
//             authorizationPassword: password,
//             transportOptions: { server: serverToCheck },
//             userAgentString,
//             uri: UserAgent.makeURI(`sip:${username}@${uriToCheck}`),
//             sessionDescriptionHandlerFactoryOptions: {
//                 peerConnectionConfiguration: {
//                     bundlePolicy: 'max-compat',
//                     iceServers: []
//                 }
//             },
//             logLevel: 'warn'
//         };
//
//         const tempUserAgent = new UserAgent(userAgentOptions);
//
//         try {
//             tempUserAgent.start().then(() => {
//                 const core = tempUserAgent.userAgentCore;
//
//                 const requestURI = UserAgent.makeURI(`sip:${username}@${uriToCheck}`);
//                 if (requestURI) {
//                     const message = core.makeOutgoingRequestMessage(
//                         'OPTIONS',
//                         requestURI,
//                         requestURI.clone(),
//                         requestURI.clone(),
//                         {}
//                     );
//                     const start = performance.now();
//                     core.request(message, {
//                         onAccept: () => {
//                             const end = performance.now();
//                             tempUserAgent.stop().then(() => {
//                                 resolve(end - start);
//                             });
//                         },
//                         onReject: () => {
//                             tempUserAgent.stop().then(() => {
//                                 resolve(Infinity);
//                             });
//                         }
//                     });
//                 }
//             });
//         } catch (error) {
//             console.warn(error);
//             resolve(Infinity);
//         }
//     });

export const getPeerConnection = (callId: string): RTCPeerConnection | undefined => {
    const found = calls.find(c => c.id === callId)
        ?.sessionDescriptionHandler as Web.SessionDescriptionHandler;

    if (!found || !found.peerConnection) return undefined;

    return found.peerConnection;
};

const listenForMediaTracks = (store: Store, session: Session) => {
    const { peerConnection } = session.sessionDescriptionHandler as Web.SessionDescriptionHandler;

    if (peerConnection) {
        peerConnection.ontrack = event => {
            switch (event.track.kind) {
                case 'audio':
                    store.dispatch(
                        callsSlice.actions.updateCall({
                            id: session.id,
                            audioTrack: event.track
                        })
                    );
                    break;

                case 'video':
                    store.dispatch(
                        callsSlice.actions.updateCall({
                            id: session.id,
                            videoTracks: [event.track]
                        })
                    );
                    break;
                default:
                    break;
            }
        };
    }
};

const setupRemoteMedia = (store: Store, session: Session) => {
    const { peerConnection } = session.sessionDescriptionHandler as Web.SessionDescriptionHandler;

    if (peerConnection) {
        peerConnection.getReceivers().forEach((receiver: { track: MediaStreamTrack }) => {
            switch (receiver.track.kind) {
                case 'audio':
                    store.dispatch(
                        callsSlice.actions.updateCall({
                            id: session.id,
                            audioTrack: receiver.track
                        })
                    );
                    break;

                case 'video':
                    store.dispatch(
                        callsSlice.actions.updateCall({
                            id: session.id,
                            videoTracks: [receiver.track]
                        })
                    );
                    break;
                default:
                    break;
            }
        });
    }
};

// const setupLocalMedia = (store: Store, session: Invitation | Inviter) => {
// (session.sessionDescriptionHandler as Web.SessionDescriptionHandler).peerConnection
//     .getSenders()
//     .forEach((receiver: { track: MediaStreamTrack }) => {
//         switch (receiver.track.kind) {
//             case 'video':
//                 store.dispatch(
//                     callsSlice.actions.updateCall({
//                         id: session.id,
//                         videoTracks: [receiver.track]
//                     })
//                 );
//                 break;
//             default:
//                 break;
//         }
//     });
// };

const enableSenderTracks = (invitation: Session, muted: boolean) => {
    const { sessionDescriptionHandler } = invitation;

    if (!(sessionDescriptionHandler instanceof SessionDescriptionHandler)) {
        throw new Error(
            "Session's session description handler not instance of SessionDescriptionHandler."
        );
    }

    const { peerConnection } = sessionDescriptionHandler;
    if (!peerConnection) return;

    peerConnection.getSenders().forEach(sender => {
        if (sender.track) {
            sender.track.enabled = !muted;
        }
    });
};

const sendDTMF = (invitation: Session, dtmf: string): void => {
    const { sessionDescriptionHandler } = invitation;

    if (!(sessionDescriptionHandler instanceof SessionDescriptionHandler)) {
        throw new Error(
            "Session's session description handler not instance of SessionDescriptionHandler."
        );
    }

    const { peerConnection } = sessionDescriptionHandler;
    if (!peerConnection) return;

    peerConnection.getSenders().forEach(sender => {
        if (sender.dtmf && sender.dtmf.canInsertDTMF) {
            sender.dtmf.insertDTMF(dtmf);
        }
    });
};

const toggleHold = (store: Store, invitation: Session, onHold: boolean) => {
    const delegate: OutgoingInviteRequestDelegate = {
        onAccept: (response): void => {
            response.ack();
            store.dispatch(
                callsSlice.actions.updateCall({
                    id: invitation.id,
                    onHold
                })
            );
            // 3) once hold is processed set to false
            callsOnHold[invitation.id] = false;
        }
    };

    // 1) if hold button clicked and not processed return
    if (callsOnHold[invitation.id]) return;

    // 2) on start set hold button to true
    callsOnHold[invitation.id] = true;

    let body = bodyDictionary[invitation.id];
    if (onHold && body?.content) {
        if (!/a=(sendrecv|sendonly|recvonly|inactive)/.test(body.content)) {
            body = {
                ...body,
                content: body.content.replace(/(m=[^\r]*\r\n)/g, '$1a=sendonly\r\n')
            };
        } else {
            body = {
                ...body,
                content: body.content.replace(/a=sendrecv\r\n/g, 'a=sendonly\r\n')
            };
            body = {
                ...body,
                content: body.content.replace(/a=recvonly\r\n/g, 'a=inactive\r\n')
            };
        }
    }

    // Send re-INVITE
    invitation?.dialog?.invite(delegate, { body });
};

const createTargetURI = (callee: string, countryCode: CountryCode): URI | undefined => {
    const parsedNumber = parsePhoneNumberFromString(callee, countryCode);
    let target = callee;

    if (parsedNumber?.isValid()) {
        target = parsedNumber.formatInternational();
    }

    if (/#/.test(callee)) {
        target = callee.replace(/#/g, '%23');
    }

    return UserAgent.makeURI(`sip:${target.replace(/\s/g, '')}@${sipServer.uri}`);
};

const PAINumberRegex = /<sip:(.*?)@/gm;
const PAINameRegex = /^"(.*?)"/gm;

const parseAssertedIdentity = (inp: string): AssertedIdentity => {
    const assertedIdentity: AssertedIdentity = { number: '' };

    const nameParse = inp.match(PAINameRegex);
    if (nameParse && nameParse[1] !== 'DDI') {
        // eslint-disable-next-line prefer-destructuring
        assertedIdentity.name = nameParse[0].replaceAll('"', '');
    }

    const numberParse = inp.match(PAINumberRegex);
    if (numberParse) {
        // eslint-disable-next-line prefer-destructuring
        assertedIdentity.number = numberParse[0].split(':')?.[1]?.replace('@', '');
    }

    return assertedIdentity;
};

export const sip =
    (store: Store) => (next: Dispatch) => (action: PayloadAction<SIPLogin | ISIPPayload | any>) => {
        const { payload, type } = action;
        const state = store.getState() as RootState;

        const settings: IPhoneSettings = (store.getState() as RootState).user?.settings?.phone
            .settings;

        if (settings?.callWaitingBeepOff) {
            callWaitingBeepOff = settings.callWaitingBeepOff;
        }

        const smartDiallerSelected = selectSmartDiallerSelected(state);
        const inviteWithoutSdp = !selectHasDevices(state);

        const crmIntegrations = selectConfiguredCrmIntegrations(state);

        const inviterOptions: InviterOptions = inviteWithoutSdp
            ? {
                anonymous: state.user?.caller_id === '0' || false,
                inviteWithoutSdp
            }
            : {
                anonymous: state.user?.caller_id === '0' || false,
                sessionDescriptionHandlerOptions: {
                    constraints: {
                        audio: {
                            deviceId:
                                state.user?.settings.phone.settings?.inputDeviceId || 'default'
                        },
                        video: false
                    }
                },
                earlyMedia: true
            };

        switch (type) {
            case 'sip/connect':
                connectSip(payload as SIPLogin, store).then();
                break;

            case 'sip/call':
                if (
                    state.sip?.calls.some(
                        call =>
                            call.state &&
                            call.callee === payload.callee &&
                            [SessionState.Initial, SessionState.Establishing].includes(call.state)
                    )
                ) {
                    break;
                }
                const target = createTargetURI(payload.callee, state.user?.country_code);

                if (!target || !userAgent) break;
                const inviter = new Inviter(userAgent, target, inviterOptions);

                if (smartDiallerSelected) {
                    const smartDiallerTarget = `${smartDiallerSelected.type}:${smartDiallerSelected.data}`;

                    inviter.request.setHeader('X-Transfer-Target', smartDiallerTarget);
                }

                if (
                    crmIntegrations &&
                    settings?.popCrm &&
                    settings.popCrm !== 'never' &&
                    settings.popOnOutbound
                ) {
                    const emisInfo: EmisCallInfo = {
                        callState: 'ringing',
                        callType: 'outbound',
                        callingNumber: partyNumber(inviter.request.from.uri.user, state.user.name, state.user.extension),
                        calledNumber: partyNumber(inviter.request.to.uri.user, state.user.name, state.user.extension),
                    };
                    crmIntegrations.forEach(integration => {
                        integrationChecker(
                            integration,
                            inviter.request.to.uri.user,
                            settings.popCrm,
                            state.user.country_code,
                            undefined,
                            state.user.uuid,
                            store.dispatch,
                            integration.name === 'EMIS' ? emisInfo : undefined
                        );
                    });
                }

                calls.forEach(call => {
                    if (call.state === SessionState.Established && call.id !== inviter.id) {
                        toggleHold(store, call, true);
                    }
                });
                state.sip.calls
                    .filter(c => c.roomId)
                    .forEach(c => {
                        store.dispatch(
                            callsSlice.actions.updateCall({
                                ...c,
                                onHold: true
                            })
                        );
                    });

                calls = [...calls, inviter];
                const callObject: ICall = {
                    id: inviter.id,
                    displayName: payload.displayName || payload.callee,
                    callee: payload.callee,
                    state: inviter.state,
                    isOutbound: true,
                    beingTransferred: false,
                    callSipId: inviter.request.callId,
                    smartDiallerData: smartDiallerSelected
                        ? {
                            type: smartDiallerSelected.type,
                            title: smartDiallerSelected.label,
                            data: smartDiallerSelected.data
                        }
                        : undefined,
                    smartDialOnly: inviteWithoutSdp,
                    isMuted: inviteWithoutSdp,
                    interTenant: payload.tenant
                };

                if (payload.beingTransferredTo) {
                    callObject.beingTransferredTo = payload.beingTransferredTo;
                }

                store.dispatch(callsSlice.actions.newCall(callObject));
                store.dispatch(
                    callsSlice.actions.setLastCalledNumber({
                        callee: payload.callee,
                        display_name: payload.display_name
                    })
                );

                handleCallDialog(inviter, store);

                inviter.stateChange.addListener((sessionState: SessionState) => {
                    console.log(`sip/call Session state changedsss to ${sessionState}`);

                    const isInternal =
                        inviter.remoteIdentity?.uri?.user &&
                        inviter.remoteIdentity?.uri?.user.length <= 5;

                    switch (sessionState) {
                        case SessionState.Initial:
                            break;

                        case SessionState.Establishing:
                            if (!inviteWithoutSdp) {
                                listenForMediaTracks(store, inviter);
                            }
                            break;

                        case SessionState.Established:
                            bodyDictionary[inviter.id] = {
                                ...(inviter.dialog?.offer as Body)
                            };

                            store.dispatch(
                                callsSlice.actions.updateCall({
                                    id: inviter.id,
                                    state: SessionState.Established,
                                    answered: true,
                                    answeredTime: moment().valueOf()
                                })
                            );

                            (window as any).electron?.send('set-touch-bar', {
                                type: 'established-call',
                                payload: {
                                    id: inviter.id,
                                    number: inviter.remoteIdentity?.uri?.user
                                }
                            });
                            break;

                        case SessionState.Terminating:
                        case SessionState.Terminated:
                            const emisIntegration = crmIntegrations?.find(
                                integration => integration.name === 'EMIS'
                            );

                            if (
                                emisIntegration &&
                                sessionState === SessionState.Terminated &&
                                settings?.popCrm &&
                                settings.popCrm !== 'never' &&
                                settings.popOnOutbound
                            ) {
                                const emisEnded: EmisCallInfo = {
                                    callState: 'ended',
                                    callType: 'outbound',
                                    callingNumber: partyNumber(inviter.request.from.uri.user, state.user.name, state.user.extension),
                                    calledNumber: partyNumber(inviter.request.to.uri.user, state.user.name, state.user.extension),
                                };

                                integrationChecker(
                                    emisIntegration,
                                    inviter.request.to.uri.user,
                                    settings.popCrm,
                                    state.user.country_code,
                                    undefined,
                                    state.user.uuid,
                                    store.dispatch,
                                    emisEnded
                                );
                            }

                            (window as any).electron?.send('set-touch-bar', { type: 'clear' });

                            if (state.sip.callFeedback.enabled && inviter.cdrUuid && !isInternal) {
                                // enable form because the call was established
                                store.dispatch(
                                    callsSlice.actions.addSingleFeedbackForm({
                                        invite_uuid: inviter.id,
                                        call_uuid: inviter.cdrUuid,
                                        note: undefined,
                                        mood: undefined,
                                        active_tags: []
                                    })
                                );
                            }
                            store.dispatch(
                                callsSlice.actions.updateCall({
                                    id: inviter.id,
                                    terminatedTime: moment().valueOf()
                                })
                            );

                            store.dispatch(
                                callsSlice.actions.callTerminating({
                                    id: inviter.id
                                })
                            );

                            setTimeout(() => {
                                store.dispatch(
                                    callsSlice.actions.callTerminated({
                                        id: inviter.id
                                    })
                                );
                                calls = calls.filter(call => call.id !== inviter.id);
                            }, 1500);
                            break;

                        default:
                            break;
                    }
                });

                inviter
                    .invite({
                        withoutSdp: inviteWithoutSdp
                    })
                    .then(request => {
                        if (request.delegate) {
                            request.delegate.onProgress = response => {
                                const { statusCode } = response.message;

                                if (
                                    statusCode === 180 &&
                                    !callStatusDictionary[inviter.id]?.did_ring
                                ) {
                                    playRingtone({
                                        callId: inviter.id,
                                        isOutbound: true,
                                        volume: state.user.settings?.phone.settings?.callVolumeValue
                                    });
                                }

                                if (statusCode === 183) {
                                    stopRingtone(inviter.id);

                                    const { peerConnection } =
                                        inviter.sessionDescriptionHandler as Web.SessionDescriptionHandler;

                                    if (
                                        peerConnection &&
                                        peerConnection.signalingState !== 'stable'
                                    ) {
                                        const description = new RTCSessionDescription({
                                            type: 'answer', // pranswer
                                            sdp: response.message.body
                                        });

                                        // TODO: Check that peer connection is stable and not set by library or don't set remove desc here.

                                        try {
                                            peerConnection.setRemoteDescription(description).then();
                                        } catch (error) {
                                            console.log('Setting remote description error', error);
                                        }
                                    }
                                }

                                if (statusCode) {
                                    callStatusDictionary = {
                                        ...callStatusDictionary,
                                        [inviter.id]: {
                                            last_code: statusCode,
                                            did_ring:
                                                callStatusDictionary[inviter.id]?.did_ring ||
                                                statusCode === 180 ||
                                                statusCode === 183
                                        }
                                    };
                                }
                            };

                            if (smartDiallerSelected) {
                                request.delegate.onReject = res => {
                                    store.dispatch({
                                        type: 'sip/end-call',
                                        payload: inviter.id
                                    });

                                    if (res.message.statusCode && res.message.statusCode !== 487) {
                                        store.dispatch(
                                            appSlice.actions.setSmartDiallerError({
                                                reasonPhrase: res.message.reasonPhrase,
                                                statusCode: res.message.statusCode,
                                                ...callObject
                                            })
                                        );
                                    }
                                };
                            }
                        }
                    })
                    .catch(() => { });
                break;

            case 'sip/answer':
                const answerInvitation = calls.find(inv => inv.id === payload) as Invitation;
                if (
                    !answerInvitation ||
                    [SessionState.Establishing, SessionState.Established].includes(
                        answerInvitation.state
                    )
                ) {
                    break;
                }

                answerInvitation.stateChange.addListener((sessionState: SessionState) => {
                    console.log(`sip/answer Session state changed to ${sessionState}`);

                    calls.forEach(call => {
                        if (
                            call.state === SessionState.Established &&
                            answerInvitation.state !== SessionState.Terminated &&
                            call.id !== answerInvitation.id
                        ) {
                            toggleHold(store, call, true);
                        }
                    });
                    state.sip.calls
                        .filter(c => c.roomId)
                        .forEach(c => {
                            store.dispatch(
                                callsSlice.actions.updateCall({
                                    ...c,
                                    onHold: true
                                })
                            );
                        });

                    switch (sessionState) {
                        case SessionState.Initial:
                        case SessionState.Establishing:
                            break;

                        case SessionState.Established:
                            setupRemoteMedia(store, answerInvitation);

                            bodyDictionary[answerInvitation.id] = {
                                ...(answerInvitation.dialog?.answer as Body)
                            };

                            store.dispatch(
                                callsSlice.actions.updateCall({
                                    id: answerInvitation.id,
                                    state: answerInvitation.state,
                                    answered: true,
                                    answeredTime: moment().valueOf()
                                })
                            );

                            calls.forEach(
                                c => c.state === SessionState.Initial && stopRingtone(c.id)
                            );

                            (window as any).electron?.send('set-touch-bar', {
                                type: 'established-call',
                                payload: {
                                    id: answerInvitation.id,
                                    number: answerInvitation.remoteIdentity?.uri?.user
                                }
                            });
                            break;

                        case SessionState.Terminating:
                        case SessionState.Terminated:
                            (window as any).electron?.send('set-touch-bar', { type: 'clear' });

                            store.dispatch(
                                callsSlice.actions.updateCall({
                                    id: answerInvitation.id,
                                    terminatedTime: moment().valueOf()
                                })
                            );

                            store.dispatch(
                                callsSlice.actions.callTerminating({
                                    id: answerInvitation.id
                                })
                            );

                            setTimeout(() => {
                                store.dispatch(
                                    callsSlice.actions.callTerminated({
                                        id: answerInvitation.id
                                    })
                                );
                            }, 1500);
                            break;

                        default:
                            break;
                    }
                });

                answerInvitation
                    .accept({
                        sessionDescriptionHandlerOptions: {
                            constraints: {
                                audio: {
                                    deviceId:
                                        state.user?.settings.phone.settings?.inputDeviceId ||
                                        'default'
                                },
                                video: false
                            }
                        }
                    })
                    .then(() => { })
                    .catch(() => { });
                break;

            case 'sip/attended-transfer':
                const originalCall = calls.find(call => call.id === payload.originalCallId);
                const newCallToBeTransferred = calls.find(
                    call => call.id === payload.currentCallId
                );

                if (
                    originalCall &&
                    newCallToBeTransferred &&
                    ![originalCall.state, newCallToBeTransferred.state].includes(
                        SessionState.Terminated
                    )
                ) {
                    try {
                        originalCall.refer(newCallToBeTransferred).then();
                    } catch (error) { }
                }
                break;

            case 'sip/blind-transfer':
                const blindTransferSession = calls.find(call => call.id === payload.callId);
                if (!blindTransferSession) break;

                const transferURI = createTargetURI(payload.secondCallee, state.user?.country_code);

                if (transferURI) {
                    blindTransferSession
                        .refer(transferURI, {
                            // Example of extra headers in REFER request
                            requestOptions: {
                                extraHeaders: [`X-Referred-By-Someone: ${payload.callee}`]
                            },
                            requestDelegate: {
                                onAccept: () => { }
                            },
                            onNotify: notification => {
                                notification.accept().then();
                            }
                        })
                        .then();
                }
                break;

            case 'sip/toggle-dtmf-pass':
                const dtmfPassSession = calls.find(call => call.id === payload.callId);
                if (dtmfPassSession) {
                    toggleDTMFPass(dtmfPassSession);
                }

                break;

            case 'sip/end-call':
                stopRingtone(payload);
                const endCallSession = calls.find(inv => inv.id === payload);
                if (!endCallSession) break;

                switch (endCallSession.state) {
                    case SessionState.Initial:
                    case SessionState.Establishing:
                        if (endCallSession instanceof Inviter) {
                            // An unestablished outgoing session
                            (endCallSession as Inviter)
                                .cancel()
                                .then(() => {
                                    store.dispatch(
                                        callsSlice.actions.callTerminated({
                                            id: endCallSession.id
                                        })
                                    );
                                })
                                .catch(err => console.warn("failed on cancel Inviter", err));
                        } else {
                            // An unestablished incoming session
                            endCallSession
                                .reject()
                                .then(() => {
                                    store.dispatch(
                                        callsSlice.actions.callTerminated({
                                            id: endCallSession.id
                                        })
                                    );
                                })
                                .catch(err => console.warn("failed on reject", err));
                        }
                        break;

                    case SessionState.Established:
                        store.dispatch(
                            callsSlice.actions.callTerminating({
                                id: endCallSession.id
                            })
                        );

                        if (endCallSession.dialog?.sessionState !== 'Terminated') {
                            endCallSession
                                .bye()
                                .then(() => {
                                    setTimeout(() => {
                                        store.dispatch(
                                            callsSlice.actions.callTerminated({
                                                id: endCallSession.id
                                            })
                                        );
                                    }, 1500);
                                })
                                .catch(err => console.warn(err));
                        }
                        break;

                    case SessionState.Terminating:
                    case SessionState.Terminated:
                        (window as any).electron?.send('set-touch-bar', { type: 'clear' });
                        store.dispatch(
                            callsSlice.actions.callTerminating({
                                id: endCallSession.id
                            })
                        );

                        setTimeout(() => {
                            store.dispatch(
                                callsSlice.actions.callTerminated({
                                    id: endCallSession.id
                                })
                            );
                        }, 1500);
                        break;
                }
                break;

            case 'sip/send-dtmf':
                const dtmfSession = calls.find(inv => inv.id === payload.callId);
                if (!dtmfSession) break;

                sendDTMF(dtmfSession, payload.dtmf);

                const { shortcodes } = state.auth;
                const shortCodesDictionary = {};
                shortcodes.forEach(sc => {
                    shortCodesDictionary[sc.short_code] = sc;
                });

                const { popParkedCallsTab } = state.user.settings.phone.settings;

                switch (shortCodesDictionary[payload.dtmf]?.feature?.feature) {
                    case 'parkretrieve':
                        store.dispatch(callsSlice.actions.setCallToParking({ id: payload.callId }));
                        if (popParkedCallsTab) {
                            store.dispatch(appSlice.actions.updateActivePhoneTab('parked'));
                            store.dispatch(appSlice.actions.updateActivePage('phone'));
                        }
                        break;
                }
                break;

            case 'sip/toggle-mute':
                const muteSession = calls.find(inv => inv.id === payload.callId);
                if (!muteSession) break;

                enableSenderTracks(muteSession, payload.muted);

                store.dispatch(
                    callsSlice.actions.updateCall({
                        id: muteSession.id,
                        isMuted: payload.muted
                    })
                );
                break;

            case 'sip/toggle-hold':
                const holdSession = calls.find(inv => inv.id === payload.callId);
                if (!holdSession) break;

                if (!payload.onHold) {
                    calls.forEach(call => {
                        if (call.state === SessionState.Established && call.id !== holdSession.id) {
                            toggleHold(store, call, true);
                        }
                    });
                }

                toggleHold(store, holdSession, payload.onHold);
                break;

            case userSlice.actions.updatePhoneSettings.type:
                switch (action.payload.setting) {
                    case 'dnd':
                        dnd = action.payload.value;
                        break;

                    case 'allowInternalCalls':
                        allowInternalCalls = action.payload.value;
                        break;

                    default:
                        break;
                }
                break;

            case 'sip/disconnect': {
                lastRegisterAt = 0;
                connectionStatus = 0;
                reconnectBackoff.reset();
                if (registerRetryTimer) { clearTimeout(registerRetryTimer); registerRetryTimer = null; }

                const staleRegisterer = registerer;
                const stoppingAgent = userAgent;
                registerer = undefined;
                userAgent = undefined;
                lock = false;

                const stopAgent = () => stoppingAgent?.stop().catch(() => { /* already stopping */ });

                if (staleRegisterer) {
                    Promise.race([
                        staleRegisterer.dispose().catch(() => { /* transport already gone */ }),
                        new Promise<void>(resolve => { setTimeout(resolve, 2_000); }),
                    ]).finally(stopAgent);
                } else {
                    stopAgent();
                }
                break;
            }

            /** CALL FEEDBACK RELATED */
            case callsSlice.actions.callTerminated.type:
                stopRingtone(payload.id);

                const terminatedCall = action.payload as ICall;
                const secondCall = calls.find(call => call.id !== terminatedCall.id);
                const {
                    sip: { callFeedback }
                } = state;

                if (
                    callFeedback.enabled &&
                    callFeedback.forms.find(form => form.invite_uuid === terminatedCall.id)
                ) {
                    if (callFeedback.forms.length === 1 || !secondCall) {
                        store.dispatch(callsSlice.actions.setShowFeedbackForm(true));
                    }
                }
                break;

            default:
                break;
        }

        return next(action);
    };
